exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-row[data-v-6c2bb1f7],\n.filter-section[data-v-6c2bb1f7] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.actions .sortable-ghost[data-v-6c2bb1f7] {\n  opacity: 0.5;\n}\n.btn-list button[data-v-6c2bb1f7] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-align: left;\n  width: 100%;\n}\n.btn-list button svg[data-v-6c2bb1f7] {\n  margin-left: auto;\n  flex-shrink: 0;\n  order: 2;\n}", ""]);

// exports
